import Moment from "moment";
import CultureInfo from "./CultureInfo";

export default class Helper {
  static FormatDate(value) {
    return value
      ? Moment(value).format(CultureInfo.GetCultureInfo().DateFormat)
      : "";
  }

  static FormatDateMMYYYY(value) {
    return value
      ? Moment(value).format(CultureInfo.GetCultureInfo().MonthWithYearFormat)
      : "";
  }

  static GetYearFromDate(date) {
    var d = new Date(date);
    try {
      return d.getFullYear();
    } catch (e) {
      return "";
    }
  }

  static FormatTime(value) {
    return value
      ? Moment(value).format(CultureInfo.GetCultureInfo().TimeFormat)
      : "";
  }

  static FormatDayWithDate(value) {
    return value
      ? Moment(value).format(CultureInfo.GetCultureInfo().DayWithDateFormat)
      : "";
  }

  static FormatDateToLocalTimeZone(value) {
    return value
      ? Moment(value).local().format(CultureInfo.GetCultureInfo().DateFormat)
      : "";
  }

  static FormatDateTime(value) {
    return value
      ? Moment(value).format(CultureInfo.GetCultureInfo().DateTimeFormat)
      : "";
  }

  static FormatDateTime24(value) {
    return value
      ? Moment(value).format(CultureInfo.GetCultureInfo().DateTimeFormat24)
      : "";
  }

  static FormatDateTimeToLocalTimeZone(value) {
    return value
      ? Moment(value)
          .local()
          .format(CultureInfo.GetCultureInfo().DateTimeFormat24)
      : "";
  }

  //... Returns a random Id string. Id length is based on the supplied length.
  static GetRandomId(length = 5) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  static IfDateIsNULL(inputDate) {
    var minDate = Moment.utc("01/01/0001"); // minimum value as per UTC

    var receiveDate = Moment(this.FormatDate(inputDate)); // replace with variable
    if (Moment.utc(receiveDate).isAfter(minDate)) {
      return false;
    } else {
      return true;
    }
  }

  static GetNameInitials(name) {
    var iChars = "";
    name &&
      name.replace(/[a-z]{2,}/gi, function (c) {
        iChars += c.charAt(0);
      });
    return iChars.toUpperCase();
  }

  static Validate(value, params) {
    let obj = { isValid: true, validationMessage: "" };

    if (
      params.Required &&
      (value === null || value === "" || value.length === 0)
    ) {
      obj.isValid = false;
      obj.validationMessage = "Please enter value";
    }
    return obj;
  }

  static MakeFirstCharCapital(value) {
    if (value && value.length > 0) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return "";
  }

  static removeStorage(key) {
    try {
      sessionStorage.removeItem(key);
      sessionStorage.removeItem(key + "_expiresIn");
    } catch (e) {
      //console.log('removeStorage: Error removing key [' + key + '] from localStorage: ' + JSON.stringify(e));
      return false;
    }
    return true;
  }
  /*  getStorage: retrieves a key from localStorage previously set with setStorage().
    params:
        key <string> : localStorage key
    returns:
        <string> : value of localStorage key
        null : in case of expired key or failure
 */
  static getStorage(key) {
    var now = Date.now(); //epoch time, lets deal only with integer
    // set expiration for storage
    var expiresIn = sessionStorage.getItem(key + "_expiresIn");
    if (expiresIn === undefined || expiresIn === null) {
      expiresIn = 0;
    }

    if (expiresIn < now) {
      // Expired
      this.removeStorage(key);
      return null;
    } else {
      try {
        var value = sessionStorage.getItem(key);
        return JSON.parse(value);
      } catch (e) {
        //console.log('getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e));
        return null;
      }
    }
  }
  /*  setStorage: writes a key into localStorage setting a expire time
    params:
        key <string>     : localStorage key
        value <string>   : localStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
 */
  static setStorage(key, value, expires) {
    if (expires === undefined || expires === null) {
      expires = 24 * 60 * 60; // default: seconds for 1 day
    } else {
      expires = Math.abs(expires); //make sure it's positive
    }

    var now = Date.now(); //millisecs since epoch time, lets deal only with integer
    var schedule = now + expires * 1000;
    try {
      if (typeof value === "string" || value instanceof String) {
        //localStorage.setItem(key, value);
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }

      sessionStorage.setItem(key + "_expiresIn", schedule);
    } catch (e) {
      //console.log('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e));
      return false;
    }
    return true;
  }

  static clearLocalStorage() {
    if (sessionStorage) {
      let app_version = sessionStorage.app_version_reps;
      sessionStorage.clear();
      if (app_version) {
        sessionStorage.setItem("app_version_dc", app_version);
      }
    }
  }

  static getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  static stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  static descendingComparator(a, b, orderBy) {
    const varA =
      typeof a[orderBy] === "string" ? a[orderBy].toUpperCase() : a[orderBy];
    const varB =
      typeof b[orderBy] === "string" ? b[orderBy].toUpperCase() : b[orderBy];

    if (varB < varA) {
      return -1;
    }
    if (varB > varA) {
      return 1;
    }
    return 0;
  }

  static cleanString(str) {
    if (!str) return ""; // Handle null or undefined case

    return str
      .toLowerCase()
      .replace(/[^\w\s]/gi, "") // Remove non-word and non-space characters
      .replace(/\s+/g, "")
      .trim();
  }

  static isPageLoadedInWebView = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();

    // iOS WebView detection
    const ios =
      /iphone|ipod|ipad/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const safari = /safari/.test(userAgent);
    const standalone = window.navigator.standalone;

    if (ios) {
      return !standalone && !safari; // iOS webview if not standalone and not Safari
    }

    // Android WebView detection, more comprehensive check
    return (
      /wv|WebView/i.test(userAgent) ||
      (/chrome|crios|firefox|fxios/.test(userAgent) &&
        /android/.test(userAgent))
    );
  };

  // static detectWebView = () => {
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   if (window.ReactNativeWebView) {
  //     return true;
  //   }

  //   // Detect Android WebView (includes WebView-specific substrings in user agent)
  //   const isAndroidWebView = /wv|WebView/i.test(userAgent);

  //   // Detect iOS WebView (Standalone mode check)
  //   const isIOSWebView =
  //     /iPhone|iPod|iPad/i.test(userAgent) &&
  //     !window.MSStream &&
  //     (navigator.standalone === false || /WebView/i.test(userAgent));

  //   const isSafariWebView =
  //     /iPhone|iPod|iPad/i.test(userAgent) &&
  //     window.webkit &&
  //     window.webkit.messageHandlers;

  //   // Return true if any condition matches
  //   return isAndroidWebView || isIOSWebView || isSafariWebView;
  // };

  static detectWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // React Native WebView will expose this
    if (window.ReactNativeWebView) {
      return true;
    }

    // Android WebView detection
    const isAndroid = /Android/i.test(userAgent);
    const isAndroidWebView = isAndroid && /\bwv\b/.test(userAgent);

    // iOS WebView detection
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

    // iOS WebView does NOT expose Safari features like standalone or full Safari UA
    const isIOSWebView =
      isIOS &&
      !isSafari &&
      (!("standalone" in navigator) || navigator.standalone === false) &&
      !/CriOS|FxiOS|OPiOS|mercury/i.test(userAgent);

    return isAndroidWebView || isIOSWebView;
  };

  static formatToLocalTimeZoneDateTime(eventDateTime) {
    return Moment.utc(eventDateTime).local().format("YYYY-MM-DD hh:mm A");
  }

  static formatEventDateTime(eventDateTime) {
    return Moment(eventDateTime).format("YYYY-MM-DD[T]HH:mm:ss");
  }

  static isHttpVideoURL(url) {
    return url.startsWith("http");
  }

  static isValidVideoInput = (value = "") => {
    const v = value.trim();

    const isHttpUrl = /^https?:\/\//i.test(v);
    const isFileName = /^[\w-]+\.[a-z0-9]+$/i.test(v);

    return isHttpUrl || isFileName;
  };
}
